import { TransactionsModal } from '@/features/transactions-modal';
import { FINAL_STATUSES } from '@/features/transactions-modal/config';

import { useTransactionsController } from '@/entities/transaction/model';

import { Header, Skeleton } from '@/shared/ui';

import { TransactionItem } from './transaction-item';

export const ProcessTransactionsWidget = () => {
  const { transactions, isLoading } = useTransactionsController();
  const inProgress = transactions.filter(
    (transaction) => !FINAL_STATUSES.includes(transaction.status),
  );
  return (
    <div className="flex h-full w-full flex-col">
      <Header
        className="pb-6"
        title={`Transactions in process · ${inProgress?.length || 0}`}
        action={
          transactions?.length
            ? {
                as: 'custom',
                render: (
                  <TransactionsModal
                    transactions={transactions}
                    showAllProcessTransactions
                    triggerClassName="w-auto"
                  />
                ),
              }
            : undefined
        }
      />

      <div className="flex h-full flex-col gap-y-3">
        {!isLoading && !transactions?.length && (
          <div className="my-auto flex h-full w-full flex-col items-center justify-center gap-1 text-center text-base-100">
            <p>There will be your transactions</p>
          </div>
        )}
        {isLoading ? (
          <div className="flex flex-col gap-4 p-4">
            {Array.from({ length: 5 }).map((i, idx) => (
              <Skeleton key={idx} className="h-8 rounded-xl" />
            ))}
          </div>
        ) : (
          transactions
            .slice(0, 4)
            .map((transaction) => (
              <TransactionItem
                transaction={transaction}
                key={transaction.id}
                classNames={{ label: 'max-w-[150px]' }}
              />
            ))
        )}
      </div>
    </div>
  );
};
